import React, { useState, useEffect } from 'react';
import api from '../utils/api';

interface ImprintData {
  name: string;
  name2: string;
  street: string;
  city: string;
  country: string;
  email: string;
  phone: string;
}

const Imprint: React.FC = () => {
  const [imprint, setImprint] = useState<ImprintData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchImprint();
  }, []);

  const fetchImprint = async () => {
    try {
      const response = await api.get('/legal/imprint');
      setImprint(response.data.data);
    } catch (error) {
      console.error('Fehler beim Laden des Impressums:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Lädt...</div>;
  }

  return (
    <div className="container">
      <div style={{
        background: 'linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)',
        borderRadius: '16px',
        padding: '30px',
        marginBottom: '30px',
        color: 'white',
        boxShadow: '0 8px 20px rgba(15, 32, 39, 0.3)'
      }}>
        <h1 style={{ margin: 0 }}>Impressum</h1>
      </div>

      <div className="card" style={{ maxWidth: '800px', margin: '0 auto' }}>
        <h2 style={{ color: '#2c5364', marginBottom: '20px' }}>Angaben gemäß § 5 TMG</h2>
        
        {imprint && (
          <div style={{ lineHeight: '1.8' }}>
            <p><strong>{imprint.name}</strong></p>
            {imprint.name2 && <p>{imprint.name2}</p>}
            <p>{imprint.street}</p>
            <p>{imprint.city}</p>
            <p>{imprint.country}</p>
            
            <h3 style={{ color: '#2c5364', marginTop: '30px', marginBottom: '15px' }}>Kontakt</h3>
            <p>
              E-Mail: <a href={`mailto:${imprint.email}`} style={{ color: '#2c5364' }}>{imprint.email}</a>
            </p>
            {imprint.phone && (
              <p>Telefon: {imprint.phone}</p>
            )}

            <h3 style={{ color: '#2c5364', marginTop: '30px', marginBottom: '15px' }}>Haftungsausschluss</h3>
            
            <h4 style={{ marginTop: '20px', marginBottom: '10px' }}>Haftung für Inhalte</h4>
            <p style={{ textAlign: 'justify' }}>
              Die Inhalte dieser Anwendung wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, 
              Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. 
              Insbesondere übernehmen wir <strong>keine Haftung für Fehler bei Berechnungen, Datenverlust 
              oder finanzielle Schäden</strong>, die durch die Nutzung dieser Anwendung entstehen könnten.
            </p>

            <h4 style={{ marginTop: '20px', marginBottom: '10px' }}>Nutzung auf eigene Gefahr</h4>
            <p style={{ textAlign: 'justify' }}>
              Diese Anwendung dient ausschließlich der privaten Finanzverwaltung. Die Nutzung erfolgt 
              auf eigenes Risiko. Es wird empfohlen, wichtige Finanzdaten regelmäßig extern zu sichern 
              und Berechnungen zu überprüfen.
            </p>

            <h4 style={{ marginTop: '20px', marginBottom: '10px' }}>Haftung für Links</h4>
            <p style={{ textAlign: 'justify' }}>
              Unser Angebot enthält möglicherweise Links zu externen Websites Dritter, auf deren Inhalte 
              wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr 
              übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder 
              Betreiber der Seiten verantwortlich.
            </p>

            <h4 style={{ marginTop: '20px', marginBottom: '10px' }}>Urheberrecht</h4>
            <p style={{ textAlign: 'justify' }}>
              Die durch den Betreiber erstellten Inhalte und Werke auf dieser Anwendung unterliegen 
              dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
              der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
              Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Imprint;
